var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgPencil = function SvgPencil(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92261 19.0617L2.93833 14.0774M7.92261 19.0617L19.0061 7.92411M7.92261 19.0617L2.93833 20.4573M2.93833 14.0774L14.076 2.99374M2.93833 14.0774L1.54273 19.0617M14.076 2.99374L15.6144 1.46285C15.7577 1.31633 15.9288 1.19991 16.1177 1.12043C16.3065 1.04094 16.5094 1 16.7143 1C16.9193 1 17.1221 1.04094 17.311 1.12043C17.4999 1.19991 17.671 1.31633 17.8143 1.46285L20.5371 4.20113C20.6813 4.34414 20.7958 4.51429 20.8739 4.70175C20.952 4.88921 20.9922 5.09028 20.9922 5.29337C20.9922 5.49645 20.952 5.69752 20.8739 5.88498C20.7958 6.07245 20.6813 6.24259 20.5371 6.3856L19.0061 7.92411M14.076 2.99374L19.0061 7.92411M1.54273 19.0617L1 21L2.93833 20.4573M1.54273 19.0617L2.93833 20.4573",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPencil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pencil.41e698c9d1b76d935e08d916a812bb3b.svg";